// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '0.3.1';
export const APP_NAME = 'ambimusic';
export const FILE_HASH = '1582215794046';
export const BUILD_DATE = '2020-02-20T16:23:14.046Z';
/* tslint:enable */
